import React from 'react';
import { CheckboxProps } from 'antd';

import {
  StyledAntdCheckbox,
} from './style';

const CVCheckbox = (props: CheckboxProps): JSX.Element => (
  <StyledAntdCheckbox {...props} />
);

export default CVCheckbox;
